import { createRoot } from "react-dom/client";
import { App } from "../../map/app";

const container = document.getElementById("leaflet-map");
if (container) {
  const root = createRoot(container);
  const className = container.getAttribute("data-className") || undefined;
  const markers = container.getAttribute("data-markers") || undefined;
  root.render(<App className={className} encodedMarkers={markers} />);
}
